/* eslint-disable */

import React from "react";
import ActivationEcotrack from "./company/ActivationEcotrack";
import ActivationMaystro from "./company/ActivationMaystro";
import ActivationElogistia from "./company/ActivationElogistia";
import ActivationGuepex from "./company/ActivationGuepex";
import ActivationNordetouest from "./company/ActivationNordetouest";
import ActivationProcolis from "./company/ActivationProcolis";
import ActivationYalidine from "./company/ActivationYalidine";
import ActivationZimou from "./company/ActivationZimou";
import ActivationAmeex from "./company/ActivationAmeex";
import ActivationColivraison from "./company/ActivationColivraison";
import ActiovationMdm from "./company/ActivationMdm";
import ActivationYalitec from "./company/ActivationYalitec";
import ActivationMylerz from "./company/ActivationMylerz";
import ActivationEcomDelivery from "./company/ActivationEcomDelivery";
import ActivationEcomDeliveryV2 from "./company/ActivationEcomDeliveryV2";
import ActivationFlashDelivery from "./company/ActivationFlashDelivery";
import ActivationZrexpress from "./company/ActivationZrexpress";
import ActivationOsen from "./company/ActivationOsen";
import ActivationDhd from "./company/ActivationDhd";
import { useTranslation } from "react-i18next";

export default function fShipCompanyActivation({ company }) {
  const { t, i18n } = useTranslation();
  if (!company) return null;

  switch (company.id) {
    case "ecotrack":
      return <ActivationEcotrack />;
    case "dhd":
      return <ActivationDhd />;

    case "elogistia":
      return <ActivationElogistia />;

    case "maystro":
      return <ActivationMaystro />;

    case "guepex":
      return <ActivationGuepex />;

    case "procolis":
      return <ActivationProcolis />;

    case "yalidine":
      return <ActivationYalidine />;

    case "nordetouest":
      return <ActivationNordetouest />;

    case "zimou":
      return <ActivationZimou />;
    case "ameex":
      return <ActivationAmeex />;
    case "colivraison":
      return <ActivationColivraison />;
    case "mdm":
      return <ActiovationMdm />;
    case "yalitec":
      return <ActivationYalitec />;
    case "mylerzdz":
      return <ActivationMylerz />;
    case "ecomDelivery":
      return <ActivationEcomDelivery />;
    case "ecomDeliveryv2":
      return <ActivationEcomDeliveryV2 />;
    case "flashDelivery":
      return <ActivationFlashDelivery />;
    case "Zrexpress_v2":
      return <ActivationZrexpress />;
    case "osen":
      return <ActivationOsen />;

    default:
      return (
        <div className="h-[420px] p-4 flex flex-col items-center justify-center text-center space-y-3 bg-white dark:!bg-[#181819] transition-colors duration-300">
          <h4 className="font-semibold text-lg text-gray-800 dark:!text-gray-200">
            {t("ShipCollectPage.unavailableService.title")}
          </h4>
          <p className="text-gray-600 dark:text-gray-400">
            {t("ShipCollectPage.unavailableService.description")}
          </p>
          <a
            href="https://wa.me/213696711953"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-block bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg transition duration-200"
          >
            {t("ShipCollectPage.unavailableService.contact")}
          </a>
        </div>
      );
  }
}
